import React from 'react'

type Props = {
    children?: React.ReactNode;
}

const PageTitleCard = (props: Props) => {
    return (
        <div className="bg-primary rounded-b-[15px] py-[14px] md:py-[14px] px-[25px]">
            {props.children}
        </div>
    )
}

export default PageTitleCard